import { ChildType, EntryType } from "@common/types/tree-types";
export interface FlatChildTypes {
  id: string;
  name: string;
  key: string;
  children?: ChildType[] | EntryType[] | undefined;
  amountOfSubNodes: number;
  selected: boolean;
  node_type?: string;
  parent;
  visible?: boolean;
  expanded?: boolean;
  transferred?: boolean;
  unassigned?: boolean;
}

export const returnIconForChild = (childInfo: FlatChildTypes | ChildType) => {
  if (childInfo.name === "Root") {
    return "root";
  }

  return childInfo.node_type === "FOLDER" ? "folder" : "file";
};
